<template>
  <a
    class="unstyled-link"
    :href="`tel:${phoneNumber}`"
  >
    <slot>
      {{ text ?? phoneNumber }}
    </slot>
  </a>
</template>

<script setup>
import { formatPhoneNumber } from '@/utils/textFormat';
import { computed, defineProps } from 'vue';

const props = defineProps({
    number: {
        type: String,
        required: true
    },
    text: {
        type: String,
        required: false
    },
    format: {
        type: Boolean,
        required: false,
        default: true
    }
});

const phoneNumber = computed(() => {
    if (props.format) {
        return formatPhoneNumber(props.number);
    }
    return props.number;
});
</script>
